var createCaseFirst=require("./_createCaseFirst"),upperFirst=createCaseFirst("toUpperCase");module.exports=upperFirst;